export enum BannerType {
  Success = "success",
  Error = "error",
  Warning = "warning",
  Info = "info"
}

export interface Banner {
  id: string;
  type: BannerType;
  message: string;
  closeable?: boolean;
  actionText?: string;
  onAction?: () => void;
  onClose?: () => void;
  duration?: number;
}
